import React from 'react'
import Grid from '@mui/material/Grid';
import { connect } from "react-redux";
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Box from '@mui/material/Box';
import RemoteDeviceTable from '../components/RemoteDeviceTable';
import LoaderComponent from "../components/LoaderComponent";
import { getRemoteDeviceLoading, getRemoteDeviceList } from "../selector/selectors";
import { loadRemoteDevice } from "../api/remotedeviceapi";
import SearchBoxComponent from '../components/SearchBoxComponent';
import { useEffect,useRef } from 'react';
import { getSocket, sessionConnectionRequest, sessionConnectionRequestClosed, sessionConnectionRequestTimeOut, sessionDisconnect, sessionUnSubscribe, connectSocket, sessionClosedRequest, sessionAcceptRequest, socketDisconnect } from '../components/SocketService';
import swal from 'sweetalert';
import { deleteSocketTimeOutRequest } from '../components/CommonApi';

const RemoteDevice = ({isLoading,startLoadingRemoteDevice,remoteDeviceList}) => {
    const socket = useRef();
    const [value, setValue] = React.useState('1');
    const [remoteDevices,setRemotDevices] = React.useState([]);
    const [preFilteredRemoteDevices,setPreFilteredRemoteDevices] = React.useState([]);

    // Function for Searching Remote Devices
    const handleChangeTextValue = (event) => {
        if(event.target.value){
            setRemotDevices(preFilteredRemoteDevices.filter((item) => item.room_id === event.target.value));
        } else {
            setRemotDevices(preFilteredRemoteDevices);
        }        
    };

    // Function for Tab
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    // Function for loading remote devices from the Database
    useEffect(() => {
        //console.log('LoadingRemoteDevice');
        startLoadingRemoteDevice();    
        // eslint-disable-next-line    
    },[startLoadingRemoteDevice]);

    // Function for assigning remote devices data to states
    useEffect(() => {
        if(remoteDeviceList){
            setRemotDevices(remoteDeviceList?.data)
            setPreFilteredRemoteDevices(remoteDeviceList?.data)
        }
    },[remoteDeviceList])

    // Function for accepting the remote socket device
    const handleSessionAccept = (event) => {
        //console.log('handleSessionAccept')
        sessionAcceptRequest(event);
    }   

    // Function for closing the remote socket device
    const handleSessionClosed = (event) => {
        //console.log('handleSessionClosed')
        sessionClosedRequest(event);
    } 
   
    // Function for handling the redirection of the page to new window
    const handleRedirect = async (event) => {
        //console.log('handleRedirect')
        const isConnectionExist = sessionStorage.getItem('connection');
        if(isConnectionExist){
            swal("Error", "Request can't be completed. A connection is already in progress.", "error");
            return false;
        }
        let connectionData  =  {'row_id':event.target.getAttribute('data-id'),'serial_number': event.target.value}
        handleSessionAccept(event);
        handleSessionClosed(event);
        sessionStorage.setItem('connection',JSON.stringify(connectionData));
        setRemotDevices((prevMessage) => prevMessage.filter((item) => item.room_id !== event.target.value))
        setPreFilteredRemoteDevices((prevMessage) => prevMessage.filter((item) => item.room_id !== event.target.value));
       const newWindow     =  window.open("/web/remote-connect",'_blank', 'width=1600,height=800');
       newWindow.socketInformation    = connectionData;
    }

    // Function for handling the redirection of the page to new window
    const handleTimeOutConnectionRequest = (param) => {
        //console.log('handleTimeOutConnectionRequest',param)
        deleteSocketTimeOutRequest(param);
    }

    // Functions for handling socket information
    useEffect(() => {
        socket.current = getSocket();
        if(socket.current){
            //console.log('socket.current',socket.current)
            connectSocket('session_request_pool');
            sessionConnectionRequest(response => {
                setRemotDevices((prevMessage) => [response?.data?.message?.data,...prevMessage]); 
                setPreFilteredRemoteDevices((prevMessage) => [response?.data?.message?.data,...prevMessage]);
            });

            sessionConnectionRequestTimeOut(response => {
                let param = {'row_id':response?.data?.message?.data?.row_id,'room_id': response?.data?.message?.data?.room_id}
                handleTimeOutConnectionRequest(param);
                setRemotDevices((prevMessage) => prevMessage.filter((item) => item.room_id !== response?.data?.message?.data?.room_id))
                setPreFilteredRemoteDevices((prevMessage) => prevMessage.filter((item) => item.room_id !== response?.data?.message?.data?.room_id));
            });

            sessionConnectionRequestClosed(response => {
                setRemotDevices((prevMessage) => prevMessage.filter((item) => item.room_id !== response?.data?.message?.data?.room_id))
                setPreFilteredRemoteDevices((prevMessage) => prevMessage.filter((item) => item.room_id !== response?.data?.message?.data?.room_id));
            });
            
            socketDisconnect(response => {
                console.log('disconnect remote',response)
            })

            return () => {
                sessionUnSubscribe('session_request_pool');
                sessionDisconnect('disconnect');
            }
        }
    },[]);
    

    return (
        <Box sx={{ flexGrow: 1 }} >
            { isLoading?<LoaderComponent />:<></> }
            <Grid container >
                <TabContext value={value}>
                    <Grid item xs={12} md={12} lg={12} >
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={handleChange} aria-label="">
                                <Tab label="Remote Devices" value="1" />      
                            </TabList>
                        </Box>        
                        <TabPanel value="1" sx={{p:0,pt:2}}> 
                            <Grid container sx={{paddingBottom:1, display: 'flex', justifyContent: 'space-between'}}>
                                <SearchBoxComponent 
                                    handleChangeTextValue = {(e)=>handleChangeTextValue(e,'')}
                                    label='Serial Number'
                                />
                            </Grid>
                            <RemoteDeviceTable handleRedirect={handleRedirect} list={remoteDevices} />       
                        </TabPanel>  
                    </Grid>    
                </TabContext>  
            </Grid>
        </Box>
    )
}


const mapStateToProps = (state) => ({
    isLoading: getRemoteDeviceLoading(state),  
    remoteDeviceList: getRemoteDeviceList(state), 
});
  
const mapDispatchToProps = (dispatch) => ({
    startLoadingRemoteDevice: (searchText,page,rowsPerPage)   => dispatch(loadRemoteDevice(searchText,page,rowsPerPage)), 
});
export default connect(mapStateToProps, mapDispatchToProps)(RemoteDevice);